import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';

import type { GlobalCopilotEntrypoint } from '../../telemetry/types';

export interface GlobalCopilotState {
  readonly isEnabled: boolean;
  readonly isOpen: boolean;
  readonly entrypoint: GlobalCopilotEntrypoint | undefined;
  readonly sessionId: string;
  readonly openDrawer: (entrypoint: GlobalCopilotEntrypoint) => void;
  readonly close: () => void;
}

const createSessionId = (): string => crypto.randomUUID();

export const useGlobalCopilotStore: UseBoundStore<StoreApi<GlobalCopilotState>> = create<GlobalCopilotState>((set) => ({
  isEnabled: false,
  isOpen: false,
  entrypoint: undefined,
  sessionId: createSessionId(),
  openDrawer: (entrypoint) => {
    set({ isOpen: true, entrypoint, sessionId: createSessionId() });
  },
  close: () => {
    set({ isOpen: false, entrypoint: undefined });
  },
}));

export const enableGlobalCopilot = (): void => {
  useGlobalCopilotStore.setState({ isEnabled: true });
};
